import React from "react";
import ReactTable from "react-table";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Table,
  Row,
  Col,
  Progress,
  Input
} from "reactstrap";

import axios from "axios";

import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";


import {
  PanelHeader,
  FormInputs,
  CardAuthor,
  CardSocials,
  Button,
  Statistics,
  AnimatedProgressProvider
} from "components";
import { easeQuadInOut } from "d3-ease";
import Select from "react-select";

import { thead, tbody, theadmobilebonuses } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import Switch from "react-bootstrap-switch";

//import Button from "components/CustomButton/CustomButton.jsx";

import moment from "moment";
import "moment/locale/es";
import { momentLocalizer } from "react-big-calendar";

var forbiddenServices = [
  "Block Information Premium Calls", 
  "Block Leisure Premium Calls", 
  "Premium SMSs Blocked", 
  "Call Forwarding Always",
  "Call Forwarding when Busy",
  "Call Forwarding when not Reachable",
  "Call Forwarding when no Reply",
  "Call_Transfer",
  "Outgoing Call Identification Restriction"
];

var internetRate = [
  { value: "14Mbps", label: "14Mbps" },
  { value: "Default", label: "Default" }
];

const SERVICIO_BOOLEAN = "serv_boolean";
const SERVICIO_STRING = "serv_string";
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

var firstCell = true;
//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});
const groupByID = groupBy("id");
const groupByNumber = groupBy("numero");

class CustomerMobileRegistries extends React.Component {
  constructor(props) {
    super(props);
    moment.locale("es");

    let monthsList = this.generateMonthList();
    // let data = this.loadData();
    let watermark = Date.now();
    // // // console.log("###### mobiles grouped ######");
    // // // console.log(this.props.mainState.mobilesGrouped);
    // let currentMobile =
    //   this.props.mainState.mobilesGrouped[this.props.match.params.mobileNumber][0];
    const groupedByNumber = groupByNumber(
      this.props.mainState.customersMobiles[this.props.match.params.customerID]
    );
    let currentMobile =
      groupedByNumber[this.props.match.params.mobileNumber][0];

    /* // // console.log(props); */
    this.state = {
      data: null,
      watermark: watermark,
      mobile: currentMobile,
      months: monthsList,
      selectedMonth: monthsList[0]
    };
    this.renderButton = this.renderButton.bind(this);
    this.loadData = this.loadData.bind(this);
    this.createServices = this.createServices.bind(this);
    this.modifyService = this.modifyService.bind(this);
    this.createUsageProgress = this.createUsageProgress.bind(this);
    this.createMobilePUK = this.createMobilePUK.bind(this);

    this.props.getMobileServicesAPI(currentMobile.numero);

    // if (!(currentMobile.numero in this.props.mainState.mobileServices) || 
    //     ((currentMobile.numero in this.props.mainState.mobileServices) && this.props.mainState.mobileServices[currentMobile.numero].watermark != watermark)) {
    //   this.props.getMobileServices(
    //     currentMobile.mobile_id,
    //     currentMobile.numero,
    //     watermark
    //   );
    // }
  }
  generateMonthList() {
    let monthQuantity = 12;
    let values = [];
    for (let index = 0; index < monthQuantity; index++) {
      let currentMonth = moment().subtract(index, "months");
      values.push({
        value: currentMonth.format("YYYY-MM"),
        label: capitalize(currentMonth.format("MMMM YYYY"))
      });      
    }
    return values;
  }
  loadData(updateState) {
    let data = [];
    let isCdrReady = this.props.mainState.mobilesCDRLoaded && this.props.match.params.mobileNumber in this.props.mainState.mobilesCDR
    && this.state.selectedMonth.value in this.props.mainState.mobilesCDR[this.props.match.params.mobileNumber]
    && this.props.mainState.mobilesCDR[this.props.match.params.mobileNumber][this.state.selectedMonth.value];
    // let isOlderCdr = this.state.selectedMonth !== this.state.months[0];
    // if (isOlderCdr) {
    //   isCdrReady = this.state.selectedMonth.value in this.props.mainState.olderCdr;
    //   if (isCdrReady) {
    //     isCdrReady = this.props.match.params.mobileNumber in this.props.mainState.olderCdr[this.state.selectedMonth.value];
    //   }
    // }
    if (isCdrReady) {
      let currentMonth = moment().format("YYYY-MM");
      let mainData = {};
      let dataOrigin = [];
      mainData = this.props.mainState.mobilesCDR[this.props.match.params.mobileNumber][this.state.selectedMonth.value].registries;
      
      // // // console.log("mainData", mainData);
      console.log("this.props.mainState.mobilesCDR", this.props.mainState.mobilesCDR);
      console.log("this.props.match.params.mobileNumber", this.props.match.params.mobileNumber);
      console.log("this.state.selectedMonth.value", this.state.selectedMonth.value);

      if ("Llamadas" in mainData) {
        dataOrigin = mainData["Llamadas"][0];
        if (dataOrigin) {
          data = dataOrigin
          .map((prop, key) => {
            // // // console.log("prop LLAMADAS", prop);
            let date = null;
            if (prop.fecha.includes("T")) {
              date = moment(prop.fecha).format(
                "YYYY/MM/DD HH:mm:ss"
              );
            } else {
              date = moment(prop.fecha, "D/MM/YYYY HH:mm:ss").format(
                "YYYY/MM/DD HH:mm:ss"
              );
            }
            return {
              id: key,
              date: date,
              destiny: prop.destino,
              description: this.cleanDescription(prop.descripcion),
              duration: parseInt(parseFloat(prop.consumo)),
              cost: prop.importe
            };
          });
        }
      }

      if ("SMS" in mainData) {
        dataOrigin = mainData["SMS"][0];
  
        if (dataOrigin) {
          data = data
          .concat(
            dataOrigin
            .map((prop, key) => {
              // // // console.log("prop SMS", prop);
              return {
                id: key,
                date: moment(prop.fecha, "D/MM/YYYY HH:mm:ss").format(
                  "YYYY/MM/DD HH:mm:ss"
                ),
                destiny: prop.destino,
                description: "(SMS) " + this.cleanDescription(prop.descripcion),
                duration: parseInt(parseFloat(prop.consumo)),
                cost: prop.importe
              };
            })
          );
        }
      }
    }

    if (updateState) {
      this.setState({
        data: data
      });
    } else {
      return data;
    }
  }
  componentDidMount() {
    // this.props.userData.getTodayDataUsage(this.state.mobile.numero);
    if (this.props.mainState.mobilesCDR) {
      if (!this.state.mobile.numero in this.props.mainState.mobilesCDR ||
        !(moment().format("YYYY-MM") in this.props.mainState.mobilesCDR[this.state.mobile.numero])) {
          this.props.userData.getMobileCdrRegistries([{number: this.state.mobile.numero, customer: this.props.match.params.customerID}]);
        }
    }
  }
  componentWillUnmount() {}
  renderButton(content, type) {
    let button = null;
    let formattedContent = null;
    let spaceAfterIcon = "    ";
    let buttonIcon = null;

    switch (type) {
      case "cost":
        buttonIcon = <i className="now-ui-icons business_money-coins" />;
        content = String(content);
        if (!content.includes(".")) content = content + ".00";
        formattedContent =
          content
            .substring(
              0,
              content.indexOf(".") > 0
                ? content.indexOf(".") + 3
                : content.length
            )
            .replace(".", ",") + " €";
        button = (
          <Button
            color={parseFloat(content) > 0 ? "danger" : "primary"}
            size="sm"
          >
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      case "duration":
        buttonIcon = <i className="now-ui-icons tech_watch-time" />;
        formattedContent = this.secondsToHms(content);
        button = (
          <Button color="default" size="sm">
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      case "sms":
        buttonIcon = <i className="now-ui-icons ui-2_chat-round" />;
        formattedContent = content + " SMS";
        button = (
          <Button color="default" size="sm">
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      case "date":
        buttonIcon = <i className="now-ui-icons ui-1_calendar-60" />;
        formattedContent = content;
        if (this.props.mainState.smallDevice) {
          formattedContent = (
            <div>
              {formattedContent.substring(0, formattedContent.indexOf(" ") + 1)}
              {<br />}
              {formattedContent.substring(formattedContent.indexOf(" ") + 1)}
            </div>
          );
        }
        button = (
          <Button color="info" size="sm">
            {!this.props.mainState.smallDevice && buttonIcon}
            {spaceAfterIcon}
            {formattedContent}
          </Button>
        );
        break;
      default:
        break;
    }

    return button;
  }
  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    // var hDisplay = h > 0 ? h + (h == 1 ? " hora " : " horas ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " minuto " : " minutos ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " segundo" : " segundos") : "";
    var hDisplay = h > 0 ? h + "h " : "";
    var mDisplay = m > 0 ? m + "m " : "";
    var sDisplay = s > 0 ? s + "s" : "";
    return hDisplay + mDisplay + sDisplay;
  }
  createDetailCards() {
    let mobileContent = null;
    let data = [];
    let isCdrReady = this.props.mainState.mobilesCDRLoaded && this.props.match.params.mobileNumber in this.props.mainState.mobilesCDR
    && this.state.selectedMonth.value in this.props.mainState.mobilesCDR[this.props.match.params.mobileNumber];
    // let isOlderCdr = this.state.selectedMonth !== this.state.months[0];
    // let currentMonth = moment().format("YYYY-MM");
    if (isCdrReady) {
      data = this.props.mainState.mobilesCDR[this.props.match.params.mobileNumber][
        this.state.selectedMonth.value
      ].registries;
      let CDR = data["Llamadas"];
      if (CDR) CDR = data["Llamadas"][0];

      let CDRSMS = data["SMS"];
      if (CDRSMS) {
        CDRSMS = data["SMS"][0];
      }
      // // // console.log("CDRSMS", CDRSMS);

      let groupByDescription = groupBy("descripcion");
      let CDRbyDescription = CDR ? groupByDescription(CDR) : null;
      let CDRSMSbyDescription = CDRSMS ? groupByDescription(CDRSMS) : null;
      //// // console.log(
      //  "####################### CDR BY DESCRIPTION #######################"
      //);
      //// // console.log(CDRbyDescription);

      if (CDR) {
        mobileContent = Object.keys(CDRbyDescription).map(
          (currentDescription, key) => {
            let totalUsage = 0;
            let totalCost = 0;
            let currentRegistries = CDRbyDescription[currentDescription];
  
            currentRegistries.map((currentRegistry, key2) => {
              totalUsage += parseInt(parseFloat(currentRegistry.consumo));
              totalCost += parseFloat(currentRegistry.importe);
            });
            totalUsage = this.renderButton(totalUsage, "duration");
            totalCost = this.renderButton(totalCost, "cost");
            return (
              <Col key={"LLAMADAS" + currentDescription} xs={12} md={4}>
                <Card className="card-stats card-raised">
                  <CardBody>
                    <Row>
                      <Col xs={12} md={12}>
                        <Statistics
                          iconState="primary"
                          icon="tech_mobile"
                          title={this.cleanDescription(currentDescription)}
                          subtitle={totalUsage + totalCost}
                          isSubtitleObject
                          isSubtitleObject2
                          subtitleObject={totalUsage}
                          subtitleObject2={totalCost}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            );
          }
        );
      }

      if (CDRSMS) {
        if (!mobileContent) mobileContent = [];
        mobileContent = mobileContent.concat(
          Object.keys(CDRSMSbyDescription).map((currentDescription, key) => {
            let totalUsage = 0;
            let totalCost = 0;
            let currentRegistries = CDRSMSbyDescription[currentDescription];
  
            currentRegistries.map((currentRegistry, key) => {
              totalUsage += parseInt(parseFloat(currentRegistry.consumo));
              totalCost += parseFloat(currentRegistry.importe);
            });
            totalUsage = this.renderButton(totalUsage, "sms");
            totalCost = this.renderButton(totalCost, "cost");
            return (
              <Col key={"SMS" + currentDescription} xs={12} md={4}>
                <Card className="card-stats card-raised">
                  <CardBody>
                    <Row>
                      <Col xs={12} md={12}>
                        <Statistics
                          iconState="primary"
                          icon="tech_mobile"
                          title={this.cleanDescription(currentDescription)}
                          subtitle={totalUsage + totalCost}
                          isSubtitleObject
                          isSubtitleObject2
                          subtitleObject={totalUsage}
                          subtitleObject2={totalCost}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            );
          })
        );
      }
    } else {
      mobileContent = (
        <Col xs={12} md={this.state.servicesSize}>
          <Card className="card-stats card-raised">
            <CardBody>
              <Row>
                <Col xs={12} md={12}>
                  <Statistics
                    showIcon
                    iconState="default"
                    icon="now-ui-icons arrows-1_refresh-69 spin"
                    title="Registros"
                    subtitle="Cargando..."
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }

    return mobileContent;
  }
  cleanDescription(description) {
    if (!description) return "Error en la descripción";
    description = description.replace("movil", "móvil");
    description = description.replace("españa", "España");
    description = description.replace("buzón", "Buzón");
    if (description === "Call_Mo_Nac_Movil") description = "Llamada móvil nacional";
    if (description === "Call_Mo_Nac_Superonnet") description = "Llamada móvil nadunet";
    if (description === "Call_Mo_Nac_Fija") description = "Llamada fijo nacional";
    if (description === "Sms_Mo_Nac_Movil") description = "SMS móvil nacional";
    if (description === "Sms_Mo_Nac_Gestion") description = "SMS interno gestión";
    if (description === "Call_Mo_Special_900") description = "Llamada 900";
    if (description.includes("Call_Mo_Int_")) description = "Llamada internacional";
    return description;
  }
  renderDestiny(number) {
    number = String(number);
    let destiny = null;
    if (number.startsWith("00")) {
      destiny = number.substring(0, 4) + " " + number.substring(4);
    } else if (number.length == 9) {
      destiny =
        number.substring(0, 3) +
        " " +
        number.substring(3, 6) +
        " " +
        number.substring(6);
    } else {
      destiny = number;
    }
    return destiny;
  }
  translateServiceName(service) {
    switch (service) {
      case "Incoming Calls Blocked":
        service = "Bloqueo de llamadas entrantes";
        break;
      case "Outgoing Calls Blocked":
        service = "Bloqueo de llamadas salientes";
        break;
      case "International Calls Blocked":
        service = "Bloqueo de llamadas internacionales";
        break;
      case "Calls to Landlines Blocked":
        service = "Bloqueo de llamadas a fijos";
        break;
      case "Calls to Mobiles Blocked":
        service = "Bloqueo de llamadas a móviles";
        break;
      case "Call Waiting":
        service = "Llamada en espera";
        break;
      case "Incoming SMSs Enabled":
        service = "SMS entrantes";
        break;
      case "Outgoing SMSs Enabled":
        service = "SMS salientes";
        break;
      case "Incoming Call Indetification":
        service = "Identificación de llamada entrante";
        break;
      case "Outgoing Call Identification Restriction":
        service = "Ocultar identificador al llamar";
        break;
      case "MultiParty Calls":
        service = "Multiconferencia (Llamada múltiple)";
        break;
      case "Lost Call Notification":
        service = "Aviso de llamada perdida";
        break;
      case "Data":
        service = "Datos (Internet)";
        break;
      case "Telephony":
        service = "Telefonía";
        break;
      case "Outgoing Roaming Calls Blocked":
        service = "Bloqueo llamadas salientes Roaming";
        break;
      case "Incoming Roaming Calls Blocked":
        service = "Bloqueo llamadas entrantes Roaming";
        break;
      case "Roaming Data Blocked":
        service = "Bloqueo de datos Roaming (Internet)";
        break;
      default:;
    }

    return service;
  }
  modifyService(value, service_id, service_type, service_name) {
    // // // console.log(
    //   "########### SERVICE MODIFIED (" + service_id + ") ###########"
    // );
    // // // console.log("########### VALUE ###########");
    // // // console.log(value);
    // // // console.log("########### TYPE ###########");
    // // // console.log(service_type);
    let service_json = null;
    switch (service_type) {
      case SERVICIO_BOOLEAN:
        service_json = {
          active: value,
          featureID: service_id
        };
        break;
      case SERVICIO_STRING:
        service_json = {
          active: true,
          featureID: service_id,
          extString: value
        };
        break;
      default:
        service_json = null;
    }
    if (service_json) {
      service_json = JSON.stringify(service_json);
    } else{
      service_json = "";
    }
    this.props.modifyMobileServicesWrapper(this.state.mobile.numero, service_json, service_name);
  }
  createServices() {
    // // // console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
    // // // console.log(this.props.mainState.mobilesCDR);
    let servicesCreated = null;

    if (this.state.mobile.numero in this.props.mainState.mobileServices /*&& this.props.mainState.mobileServices[this.state.mobile.numero].watermark == this.state.watermark*/) {
      //// // console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
      //// // console.log(this.props.mainState.mobilesCDR);
      try {
        let foundServices = this.props.mainState.mobileServices[
          this.state.mobile.numero
        ].services.item.serviceList;/*respuesta_api.subscriptionProfileResult.item.serviceList;*/
        let switchesServices = foundServices.map((service, key) => {
          if (service.userModifiable === "false") return null;
          if (forbiddenServices.includes(service.featureName)) return null;
          let isSwitch = service.featureModel !== "StringValuedService.xsd";
          let serviceWidget = null;
          let isInternetRate =
            service.featureID === "Internet" || service.featureID === "LTE";
          if (isSwitch) {
            serviceWidget = (
              <div>
                <Switch
                  onText={<i className="now-ui-icons ui-1_check" />}
                  offText={<i className="now-ui-icons ui-1_simple-remove" />}
                  defaultValue={service.active === "true"}
                  disabled={service.userModifiable === "false"}
                  onColor="success"
                  offColor="danger"
                  onChange={event => {
                    // // // console.log("######## ONCHANGE EVENT ########");
                    // // // console.log(event);
                    this.modifyService(event.state.value, service.featureID, SERVICIO_BOOLEAN, service.featureName);
                  }}
                  // labelText={service.featureName}
                />
                <span> {this.translateServiceName(service.featureName)}</span>
              </div>
            );
          } else {
            if (isInternetRate) {
              return null;
              serviceWidget = (
                <div>
                  <FormGroup>
                    <Label md={3}>
                      {service.featureName + " (" + service.extString + ")"}{" "}
                    </Label>
                    <Select
                      className="react-select primary"
                      classNamePrefix="react-select"
                      placeholder="Velocidad"
                      name={"velocidad" + service.featureID}
                      // value={service.extString}
                      options={internetRate}
                      // onChange={value => this.setState({ selectedPlan: value })}
                      onChange={value => {
                        // // // console.log("######## ONCHANGE EVENT ########");
                        // // // console.log(value);
                        this.modifyService(value.value, service.featureID, SERVICIO_STRING, service.featureName);
                      }}
                    />
                  </FormGroup>
                </div>
              );
            } else {
              try {
                serviceWidget = (
                  <div>
                    <FormGroup>
                      <Label md={3}>{service.featureName}</Label>
                      <Input
                        type="text"
                        value={service.extString}
                        disabled={service.userModifiable === "false"}
                        onChange={value => {
                          // // // console.log("######## ONCHANGE EVENT ########");
                          // // // console.log(value);
                          this.modifyService(value, service.featureID, SERVICIO_STRING, service.featureName);
                        }}
                      />
                    </FormGroup>
                  </div>
                );
              } catch (error) {
                // // // console.log("######## ERROR CREATING SERVICE #######");
                // // // console.log(error);
              }
            }
          }
          return <div key={service.featureID}>{serviceWidget}</div>;
        });
        servicesCreated = (
          <div>
            <div className="text-left">{switchesServices}</div>
            <br />
          </div>
        );
      } catch (error) {
        servicesCreated = (
          <div>
            <div className="text-center">
              <i className="now-ui-icons travel_info" /> No se pudieron cargar los servicios
            </div>
            <br />
          </div>
        );
      }
    } else {
      servicesCreated = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando...
          </div>
          <br />
        </div>
      );
    }

    return servicesCreated;
  }
  remainingUsage(usage, type, maxUsage) {
    let remainingUsage = 0;
    maxUsage = parseFloat(maxUsage);
    switch (type) {
      case "Llamadas":
        remainingUsage = maxUsage - Math.ceil(usage / 60);
        break;
      case "Datos":
        remainingUsage = (maxUsage * 1024 - usage / (1024 * 1024)) / 1024;
        break;
    }
    return remainingUsage;
  }
  getMaxUsageByType(mobile, currentDescription) {
    switch (currentDescription) {
      case "Llamadas":
        return parseFloat(mobile.minutos);
      case "Datos":
        return parseFloat(mobile.gigas);
      default:
        return 0;
    }
  }
  getRemainingUsageTextByType(remainingUsage, currentDescription, cdrIsReady) {
    let isLoading = !cdrIsReady;
    let loading = <i className="now-ui-icons arrows-1_refresh-69 spin" />;
    switch (currentDescription) {
      case "Llamadas":
        return (
          <div style={{textAlign:"center", lineHeight: "17px"}}>
            <span style={{fontSize:10}}>Quedan</span><br />
            <span style={{fontSize:20, fontWeight:"bold"}}>
              {isLoading ? loading : Math.round(remainingUsage).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
            </span><br />
            <div style={{marginTop:-5}}><span style={{fontSize:10}}>minutos</span></div>
          </div>
        );
      case "Datos":
        remainingUsage = String(remainingUsage);
        if (!remainingUsage.includes("."))
          remainingUsage = remainingUsage + ".00";
        remainingUsage = remainingUsage
          .substring(
            0,
            remainingUsage.indexOf(".") > 0
              ? remainingUsage.indexOf(".") + 3
              : remainingUsage.length
          )
          .replace(".", ",");
        return (
          <div style={{textAlign:"center", lineHeight: "17px"}}>
            <span style={{fontSize:10}}>Quedan</span><br />
            <span style={{fontSize:20, fontWeight:"bold"}}>
              {isLoading ? loading : remainingUsage}
              {/* <span style={{fontSize:10}}>GB</span> */}
            </span><br />
            <div style={{marginTop:-5}}><span style={{fontSize:10}}>gigas</span></div>
            
          </div>);
      default:
        return 0;
    }
  }
  createUsageProgress(mobile) {
    // console.log("mobile", mobile);
    let usageCreated = null;
    if (this.props.mainState.mobilesCDR) {
      let CDR = {
        cdr: {}
      };
      let currentMobileNumberInt = undefined;
      if (mobile.mobile) currentMobileNumberInt = parseInt(mobile.mobile);
      if (mobile.numero) currentMobileNumberInt = parseInt(mobile.numero);
      let cdrIsReady = false;
      if (currentMobileNumberInt in this.props.mainState.mobilesCDR) {
        let currentMonth = this.state.selectedMonth.value;
        let auxCDR = this.props.mainState.mobilesCDR[currentMobileNumberInt];
        if (currentMonth in auxCDR) {
          auxCDR = auxCDR[currentMonth].summup;
          CDR.cdr = auxCDR;
          cdrIsReady = true;
        }
      } 
      
      let dataUsage = undefined;
      if (mobile.gigas > 0) {
        let currentCDRType = "Datos";
        let currentCDR = CDR.cdr[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage += currentCDR.consumo;
        }
        if (parseInt(mobile.mobile) in this.props.mainState.todayDataUsage) {
          try {
            let todayUsage = this.props.mainState.todayDataUsage[parseInt(mobile.mobile)];
            if (!todayUsage) {
              todayUsage = [];
            } else {
              // usage = 0.0;
            }
            if (todayUsage && todayUsage.length > 0) {
              try {
                usage = parseFloat(usage);
                todayUsage.map(todayUsageElemen => {
                  usage += parseFloat(todayUsageElemen.trafficUnits);
                });
              } catch (error) {
                try {
                  let usageArrayWrapper = [];
                  usageArrayWrapper.push(todayUsage);
                  usage = parseFloat(usage);
                  usageArrayWrapper.map(todayUsageElemen => {
                    usage += parseInt(todayUsageElemen.trafficUnits);
                  });
                } catch (error2) {
                  // // // console.log("Error al obtener el consumo de hoy");
                  // // // console.log(error2);
                }
              }
            }
          } catch (error) {
            // console.error(error);
          }
        }
        // // // console.log("############# CDR tipo actual [" + currentCDRType + "] - CALCULADO (usage) ################");
        // // // console.log(usage);
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        // // // console.log("############# CDR tipo actual [" + currentCDRType + "] - CALCULADO (maxUsage) ################");
        // // // console.log(maxUsage);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        // let usageText = this.getRemainingUsageTextByType(remainingUsage, currentCDRType);
        dataUsage = (
          <Col key={currentCDRType} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentCDRType === "Datos") ? "#5279BF" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentCDRType, cdrIsReady)}
                    </CircularProgressbarWithChildren>
                  );
                }}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      }
      
      let voiceUsage = undefined;
      if (mobile.minutos > 0) {
        let currentCDRType = "Llamadas";
        let currentCDR = CDR.cdr[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage += currentCDR.consumo;
        }
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        voiceUsage = (
          <Col key={currentCDRType} xs={12} md={3}>
            <ProgressWrapper label="Counterclockwise">
              <AnimatedProgressProvider
                valueStart={maxUsage}
                valueEnd={remainingUsage}
                duration={1.4}
                easingFunction={easeQuadInOut}
              >
                {value => {
                  const roundedValue = value;
                  return (
                    <CircularProgressbarWithChildren
                      value={value}
                      maxValue={maxUsage}
                      counterClockwise
                      strokeWidth={12}
                      styles={buildStyles({
                        textColor: "black",
                        pathColor: (currentCDRType === "Datos") ? "#5279BF" :"#46B98A",
                        trailColor: "#D8D9DD",
                        pathTransition: "none"
                      })}
                    >
                      {this.getRemainingUsageTextByType(roundedValue, currentCDRType, cdrIsReady)}
                    </CircularProgressbarWithChildren>
                  );
                }}
              </AnimatedProgressProvider>
            </ProgressWrapper>
          </Col>
        );
      }
      usageCreated = [dataUsage, voiceUsage];
    } else {
      usageCreated = 
        <Col xs={12} md={9}>
          <Statistics
            showIcon
            iconState="default"
            icon="now-ui-icons arrows-1_refresh-69 spin"
            title="Móviles"
            subtitle="Cargando..."
          />
        </Col>;
    }
    return usageCreated;
  }
  createMobilePUK() {
    let currentNumber = this.state.mobile.numero;
    let currentServices = this.props.mainState.mobileServices;
    if (currentNumber in currentServices
        && currentServices[currentNumber].puk) {
      return (
        <Card>
          <CardHeader>
            <h5 className="title text-center">PUK</h5>
          </CardHeader>
          <CardBody>
            {/* <span className="text-center">{currentServices[currentNumber].puk}</span> */}
            <form>
              <FormInputs
                ncols={["col-md-12 pr-1"]}
                proprieties={[
                  {
                    label: "",
                    inputProps: {
                      disabled: true,
                      type: "text",
                      disabled: true,
                      defaultValue: currentServices[currentNumber].puk
                    }
                  }
                ]}
              />
            </form>
          </CardBody>
        </Card>
      );
    } else {
      return null;
    }
  }
  createMonthSelection() {
    return (
      <Card>
        <CardHeader>
          <h5 className="title text-left">Periodo</h5>
        </CardHeader>
        <CardBody>
          <FormGroup>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              placeholder="Seleccionar periodo"
              name={"periodo-consumo"}
              value={this.state.selectedMonth}
              options={this.state.months}
              // onChange={value => this.setState({ selectedPlan: value })}
              onChange={value => {
                this.setState({ selectedMonth: value });
                this.props.userData.getMobileCdrRegistries([{number: this.state.mobile.numero, customer: this.props.match.params.customerID}], value.value);
                let mobiles = [];
                mobiles.push(this.state.mobile.mobile);
                // this.props.userData.getMobilesCDRSummup(mobiles, value.value);
              }}
            />
          </FormGroup>
        </CardBody>
      </Card>
    );
  }
  buildCoverage(mobile) {
    let coverageStyle = {};
    if (mobile.cobertura) {
      coverageStyle = {
        position: "relative",
        display: "inline-block",
        width: "25px",
        height: "25px",
        borderRadius: "50%",
        marginBottom: "-1px",
        marginRight: "5px",
        background: mobile.cobertura.cobertura[0].color
      };
      // let coverage = mobile.cobertura.nombre.toLowerCase();
      // if (coverage.startsWith("m")) {
      //   coverageStyle = {
      //     position: "relative",
      //     display: "inline-block",
      //     width: "25px",
      //     height: "25px",
      //     borderRadius: "50%",
      //     marginBottom: "-1px",
      //     marginRight: "5px",
      //     background: "#009EF7"
      //   }
      // }
      // if (coverage.startsWith("o")) {
      //   coverageStyle = {
      //     position: "relative",
      //     display: "inline-block",
      //     width: "25px",
      //     height: "25px",
      //     borderRadius: "50%",
      //     marginBottom: "-1px",
      //     marginRight: "5px",
      //     background: "#FF7900"
      //   }
      // }
    }
    return <div style={coverageStyle}></div>;
  }
  render() {
    // // console.log("state & mainState", { state: this.state, mainState: this.props.mainState });
    let isCdrReady = this.props.mainState.mobilesCDRLoaded && this.props.match.params.mobileNumber in this.props.mainState.mobilesCDR;
    if(isCdrReady && !this.state.data) this.loadData(true);
    let services = this.createServices();
    let usageData = this.createUsageProgress(this.state.mobile);
    let mobilePUK = this.createMobilePUK();
    let monthSelection = this.createMonthSelection();
    return (
      <div>
        <PanelHeader
          content={
            <div className="header text-center">
              <h2 className="title">
                {(<span>{this.buildCoverage(this.state.mobile)}<span>{this.props.match.params.mobileNumber.substring(0,3) + " " + this.props.match.params.mobileNumber.substring(3,6) + " " + this.props.match.params.mobileNumber.substring(6,9)}</span></span>)}
                {/* {this.props.match.params.mobileNumber.substring(0, 3) +
                  " " +
                  this.props.match.params.mobileNumber.substring(3, 6) +
                  " " +
                  this.props.match.params.mobileNumber.substring(6, 9)} */}
              </h2>
              <p className="category">Lista de registros del móvil</p>
            </div>
          }
        />
        <div className="content">
          <Row>
            <Col xs={12} md={4}>
              {monthSelection}
              {mobilePUK}
              <Card>
                <CardHeader>
                  <h5 className="title">Consumo</h5>
                </CardHeader>
                <CardBody><Row>{usageData}</Row></CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <h5 className="title">Servicios</h5>
                </CardHeader>
                <CardBody>{services}</CardBody>
              </Card>
            </Col>
            <Col xs={12} md={8}>
              <Row>{this.createDetailCards()}</Row>
              {isCdrReady && this.state.data && <Row>
                <Col xs={12} md={12}>
                  <Card>
                    <CardHeader>
                      <CardTitle tag="h4">Registro de llamadas</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <ReactTable
                        data={this.loadData()}
                        filterable
                        columns={[
                          {
                            Header: "Fecha",
                            headerClassName: "text-center",
                            className: "text-center",
                            accessor: "date",
                            id: "date",
                            minWidth: 100,
                            filterable: false,
                            Cell: row => (
                              <div>
                                {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                                {this.renderButton(row.value, "date")}
                              </div>
                            )
                          },
                          {
                            Header: "Destino",
                            headerClassName: "text-center",
                            className: "text-center",
                            accessor: "destiny",
                            sortMethod: (a, b) => {
                              return parseInt(a) > parseInt(b) ? 1 : -1;
                            },
                            Cell: row => (
                              <div>
                                {this.renderDestiny(row.value)}
                                {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                                {/* this.renderButton(row.value, "duration") */}
                              </div>
                            )
                          },
                          {
                            Header: "Descripción",
                            headerClassName: "text-center",
                            className: "text-center",
                            accessor: "description",
                            show: !this.props.mainState.smallDevice
                          },
                          {
                            Header: "Duración",
                            headerClassName: "text-center",
                            className: "text-center",
                            accessor: "duration",
                            Cell: ({ row, original }) => {
                              if (firstCell) {
                                firstCell = false;
                              }
                              return (
                                <div>
                                  {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                                  {this.renderButton(
                                    row.duration,
                                    row.description.includes("SMS")
                                      ? "sms"
                                      : "duration"
                                  )}
                                </div>
                              );
                            },
                            show: !this.props.mainState.smallDevice
                          },
                          {
                            Header: "Coste",
                            headerClassName: "text-center",
                            className: "text-center",
                            accessor: "cost",
                            sortMethod: (a, b) => {
                              return parseFloat(a) > parseFloat(b) ? 1 : -1;
                            },
                            Cell: row => (
                              <div>
                                {/*prop.importe.substring(0, prop.importe.length - 2) + " €"*/}
                                {this.renderButton(row.value, "cost")}
                              </div>
                            )
                          } /* ,
                          {
                            Header: "Actions",
                            accessor: "actions",
                            sortable: false,
                            filterable: false
                          } */
                        ]}
                        defaultSorting={[
                          {
                            id: "date",
                            desc: true
                          }
                        ]}
                        defaultPageSize={20}
                        defaultFilterMethod={(filter, row) =>
                          String(row[filter.id])
                            .toLowerCase()
                            .includes(filter.value.toLowerCase())
                        }
                        showPaginationTop
                        showPaginationBottom={false}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        loadingText="Cargando..."
                        noDataText="No hay registros"
                        pageText="Página"
                        ofText="de"
                        rowsText="filas"
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function ProgressWrapper(props) {
  return (
    <div className="statistics" style={{ textAlign: "-webkit-center" }} >
      <div /* style={{ marginTop: 30, display: "flex" }} */>
        <div style={{ width: 100 }}>{props.children}</div>
        {/* <div style={{ marginLeft: 30 }}>
          <h3 className="h5">{props.label}</h3>
          <p>{props.description}</p>
        </div> */}
      </div>
    </div>
  );
}

export default CustomerMobileRegistries;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerMobileRegistries.jsx